export default "__VITE_ASSET__DdSqj_cp__"